'use strict';


function equal(x, y) {
  return +(x === y);
}

var max = 2147483647;

var min = -2147483648;

exports.equal = equal;
exports.max = max;
exports.min = min;
/* No side effect */



//////////////////
// WEBPACK FOOTER
// /usr/local/lib/node_modules/bs-platform/lib/js/js_int.js
// module id = 44
// module chunks = 0